/**
 * <accordion-custom>
 *
 * Wraps a native <details>/<summary> and adds:
 *   - default open/closed state per breakpoint via attributes
 *     open-by-default-on-mobile / open-by-default-on-desktop
 *   - close-with-escape via attribute close-with-escape
 *   - disable click-to-toggle on mobile/desktop via data attributes
 *
 * Vanilla version — mirrors sporttrader-shopify but without
 * `@theme/utilities` imports (laag1 has no build pipeline).
 */
(function () {
  if (customElements.get('accordion-custom')) return;

  var MOBILE_MAX = 749;
  var mediaQueryLarge = window.matchMedia('(min-width: ' + (MOBILE_MAX + 1) + 'px)');
  function isMobileBreakpoint() {
    return !mediaQueryLarge.matches;
  }

  class AccordionCustom extends HTMLElement {
    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this._onMediaChange = this._onMediaChange.bind(this);
    }

    get details() {
      return this.querySelector('details');
    }

    get summary() {
      var d = this.details;
      return d ? d.querySelector('summary') : null;
    }

    get disableOnMobile() {
      return this.dataset.disableOnMobile === 'true';
    }

    get disableOnDesktop() {
      return this.dataset.disableOnDesktop === 'true';
    }

    get closeWithEscape() {
      return this.dataset.closeWithEscape === 'true';
    }

    connectedCallback() {
      this._setDefaultOpenState();
      this.addEventListener('keydown', this._onKeyDown);
      if (this.summary) this.summary.addEventListener('click', this._onClick);
      if (mediaQueryLarge.addEventListener) {
        mediaQueryLarge.addEventListener('change', this._onMediaChange);
      } else if (mediaQueryLarge.addListener) {
        mediaQueryLarge.addListener(this._onMediaChange);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this._onKeyDown);
      if (this.summary) this.summary.removeEventListener('click', this._onClick);
      if (mediaQueryLarge.removeEventListener) {
        mediaQueryLarge.removeEventListener('change', this._onMediaChange);
      } else if (mediaQueryLarge.removeListener) {
        mediaQueryLarge.removeListener(this._onMediaChange);
      }
    }

    _onClick(event) {
      var mobile = isMobileBreakpoint();
      var desktop = !mobile;
      if ((mobile && this.disableOnMobile) || (desktop && this.disableOnDesktop)) {
        event.preventDefault();
      }
    }

    _onMediaChange() {
      this._setDefaultOpenState();
    }

    _setDefaultOpenState() {
      if (!this.details) return;
      var mobile = isMobileBreakpoint();
      this.details.open =
        (mobile && this.hasAttribute('open-by-default-on-mobile')) ||
        (!mobile && this.hasAttribute('open-by-default-on-desktop'));
    }

    _onKeyDown(event) {
      if (event.key === 'Escape' && this.closeWithEscape) {
        event.preventDefault();
        if (this.details) this.details.open = false;
        if (this.summary) this.summary.focus();
      }
    }
  }

  customElements.define('accordion-custom', AccordionCustom);
})();
